import type { Dictionary } from './en'

export const ja = {
  nav: { features: '機能', pricing: '価格', faq: 'よくある質問', account: 'アカウント', signIn: 'サインイン' },
  hero: {
    title: 'Mac のための Alt-Tab',
    tagline: 'macOS はアプリを切り替えます。AppSwitch は ⌥Tab でウインドウを切り替えます。同じアプリで開いた三つの書類も含め、すべてのウインドウが対象です。',
    download: 'Mac 用をダウンロード', seePricing: '価格を見る',
    note: '無料 · macOS 15 以降 · Apple シリコンと Intel',
    hint: '⌥ を押しながら Tab、離すと切り替わります',
  },
  features: {
    heading: 'ウインドウを二十枚開いたままの人へ',
    sub: '⌥Tab を一度押せばすべて並びます。離せばそこに移動します。',
    items: [
      { title: 'アプリ単位ではなく、ウインドウ単位', body: 'macOS の切り替えはアプリ単位です。AppSwitch はウインドウ単位で切り替えます。同じアプリで開いた三つの書類も含みます。' },
      { title: 'キーボード中心', body: '⌥Tab で進み、⌥⇧Tab で戻り、矢印キーでグリッド内を移動。⌥ を離すと選んだウインドウが手前に来ます。' },
      { title: 'フォーカスを奪わない', body: '実際に選ぶまで、元のアプリはアクティブなままです。AppSwitch はメニューバーに常駐し、Dock にアイコンを置きません。' },
      { title: 'ライブプレビュー', body: '汎用のアプリアイコンではなく、各ウインドウの実際の内容が見えます。最小化したウインドウも切り替え画面にそのまま並びます。' },
    ],
  },
  pricing: {
    heading: '一度の購入で、ずっとあなたのもの。',
    sub: '切り替え機能そのものは無料で完全版です。試用版でも機能制限版でもありません。Pro はライセンスが必要な二つの機能を追加します。',
    free: '無料', pro: 'Pro', ribbon: '買い切り',
    freePrice: '¥0', once: '買い切り',
    freeSub: '⌘Tab をやめるのに必要なものはすべて。',
    proSub: 'サブスクリプションなし。自動更新は一切ありません。',
    freeList: ['⌥Tab による本格的なウインドウ切り替え', 'キーボードとマウスの操作', 'グリッド表示とリスト表示', 'メニューバー常駐、Dock アイコンなし'],
    proList: ['無料版のすべて', '各ウインドウのライブプレビュー', '最小化したウインドウも切り替え画面に', '1 ライセンスで 2 台の Mac'],
    download: 'ダウンロード', buy: 'AppSwitch Pro を購入', buyBusy: '決済画面を開いています…',
    freeFoot: 'アカウント不要。カード不要。期限なし。',
  },
  faq: {
    heading: 'よくある質問',
    items: [
      { q: 'なぜアクセシビリティ権限が必要ですか。', a: '他のアプリより先に ⌥Tab を受け取り、ウインドウを列挙し、手前に出すには macOS 上これしか方法がありません。この権限がないとアプリは動作しません。システム設定でご自身が許可し、いつでも取り消せます。' },
      { q: 'サブスクリプションですか。', a: 'いいえ。AppSwitch Pro は買い切りです。自動更新も追加請求もなく、現行メジャーバージョンのアップデートが含まれます。' },
      { q: '何台の Mac で使えますか。', a: '1 ライセンスにつき 2 台です。アカウントページまたはアプリからいつでも解除できるので、機種変更でサポートに連絡する必要はありません。' },
      { q: 'ウインドウ名はどこかに送信されますか。', a: 'いいえ。ウインドウの内容も、名前も、キー入力も Mac の外に出ません。アプリが行う唯一の通信はライセンス確認で、Pro を購入した場合のみです。無料版は一切通信しません。' },
      { q: '対応する macOS のバージョンは。', a: 'macOS 15 以降、Apple シリコンと Intel の両方に対応します。' },
    ],
  },
  listMode: {
    heading: 'ウインドウの見せ方は二通り',
    sub: 'メニューバーから、または切り替え画面を開いたまま「,」キーで切り替えます。',
    grid: { title: 'グリッド表示、プレビュー付き', body: '実際の内容のサムネイル。中身でウインドウを見分けている人に向いています。' },
    list: { title: 'リスト表示、完全なタイトル', body: '各ウインドウの完全な名前が一行に収まる、密度の高い一列表示。ターミナルが二十枚あるとき、末尾だけが違うファイル名のときに向いています。' },
  },

  footer: { terms: '利用規約', privacy: 'プライバシーポリシー' },
  consent: {
    text: 'どのページが役に立っているかを知るために Google アナリティクスを使用します。同意がない限り計測は行いません。詳しくは',
    privacyLink: 'プライバシーポリシー', accept: '同意する', decline: '拒否する',
  },
} satisfies Dictionary
